import styles from '../Components/styles/InventoryOverviewPopup.module.scss';
import stylesMobile from '../Components/styles/InventoryOverviewMobile.module.scss';
import PersonPopup from './PersonPopup';

type Props = {
  personList: any[];
  isMobile: boolean;
  showPersonalData?: boolean;
};

const PersonPopupWrapper = ({ personList, isMobile, showPersonalData }: Props) => {
  if (personList.length > 0) {
    return (
      <div className={styles.contactSimplifiedView}>
        <h4
          className={
            isMobile
              ? `${stylesMobile.contactElements} ${styles.h4}`
              : `${styles.inlineElements} ${styles.h4}`
          }
        ></h4>
        {personList.map(contact => (
          <PersonPopup
            contact={contact}
            showPersonalData={showPersonalData}
            showWarningIfPersonNotAtCern
          />
        ))}
      </div>
    );
  } else {
    return <></>;
  }
};

PersonPopupWrapper.defaultProps = {
  isMobile: false,
};

export default PersonPopupWrapper;
